import {
  ClassAndSubjectPopup,
  IClassAndSubjectSelected,
  IStyles,
  IconWrapper,
  NoContentCard,
  SecondaryButton,
  deserify,
  getDeviceType,
  getMediaBasePath,
  pxToRem,
  pxTovW,
  theme,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../reduxStore/reduxHooks';
import { ANALYTICS_CLASS_SELECTION } from '../../../routeHandling/RoutesNomenclature';
import { getSubjectsMap } from '../../../utils/icons';
import { interactionEvent } from '../../Auth/auth.events';
import {
  setClassSubjectAnalysis,
  setSelectedClassInfo,
} from '../reducer/analytics.slice';
import { StudentSection } from './components/StudentSection';
import { ClassScore } from './components/classScoreCard';
import { Shimmer } from './shimmer';
import { useGlobalContext } from '../../../app/Context/GlobalContextProvider';
import { width } from '@mui/system';
import { useDownloadContext } from '../../../app/Context/DownloadContextProviderV2';
const styles: IStyles = {
  root: {
    width: '100%',
    paddingLeft: { xs: pxToRem(0), md: pxToRem(20), lg: pxTovW(241) },
    paddingTop: { xs: pxToRem(20), md: pxToRem(20), lg: pxTovW(40) },
    paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
    paddingRight: { md: pxToRem(20), lg: 0 },
    boxSizing: 'border-box',
    overflowX: 'hidden',
  },
  classHeader: {
    width: { xs: '100%', md: '95%' },
    display: 'flex',
    // flexDirection: 'column',

    // paddingTop: { xs: pxToRem(20), md: pxTovW(40) },
    paddingBottom: { xs: pxToRem(20), md: pxTovW(40) },
    gap: { xs: pxToRem(10), md: pxTovW(22) },
    justifyContent: 'space-between',
    //
    // alignItems: 'center',
  },
  header: {
    width: '100%',
    display: 'flex',
    // flexDirection: 'column',
    paddingBottom: { xs: pxToRem(20), md: pxTovW(18) },
    gap: { xs: pxToRem(10), md: pxTovW(22) },
    //
    marginLeft: { xs: pxToRem(20), md: pxTovW(0) },
    alignItems: 'center',
    // backgroundColor: 'red',
  },
  iconCard: {
    width: { xs: '90vw', md: '100%', lg: pxTovW(554) },
    height: { xs: pxToRem(81), md: pxTovW(160), lg: pxTovW(121) },
    borderRadius: pxToRem(10),
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0DFDE',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: pxToRem(10),
    boxSizing: 'border-box',
    boxShadow: `0px 0px ${pxToRem(10)} #0000001F`,
    marginLeft: { xs: pxToRem(0), md: pxTovW(0) },
  },
  classScore: {
    width: { xs: '100vw', md: '100%', lg: pxTovW(554) },
    height: { xs: pxToRem(86), lg: pxTovW(121) },
    borderRadius: { md: pxToRem(10) },
    padding: {
      xs: `${pxTovW(30)} ${pxTovW(30)} ${pxTovW(30)} ${pxTovW(30)}`,
      lg: `${pxTovW(29)} ${pxTovW(19)}`,
    },
    alignItems: 'center',
    border: '1px solid #E0DFDE',
    display: 'flex',
    boxSizing: 'border-box',
    boxShadow: `0px 0px ${pxToRem(10)} #0000001F`,
    // backgroundColor: 'red',
  },
  dropDownButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '17px 20px 16px 20px',
    border: '1px solid #0AA34FAB',

    height: pxTovW(56),
    borderRadius: pxTovW(15),
    // marginTop: pxTovW(18),
    // marginBottom: pxTovW(20),
  },
  iconBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(4), md: pxTovW(8) },
    flexDirection: 'column',
  },
  iconInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(5.5), md: pxTovW(7.5) },
  },
};
export const ClassScorePage = () => {
  const largeScreen = useMediaQuery(theme.breakpoints.up('md'));
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const [modalState, setModalState] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isIpadOnly } = useGlobalContext();
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<boolean>(false);
  const deviceType = getDeviceType();
  const android = window.Android;
  const { selected_class_info } = deserify(
    useAppSelector((state) => state.analytics)
  );
  const { TeacherAnalysisAPIServiceV2ClientWithStatusCodeHandler } =
    useCommonServiceClientContext();
  const ClassSubjectAnalysisData = deserify(
    useAppSelector((state) => state.analytics.class_subject_analysis)
  );
  useEffect(() => {
    fetchClassStudentAnalytics(selected_class_info);
  }, []);

  async function fetchClassStudentAnalytics(
    selectedClassInfo: IClassAndSubjectSelected | undefined
  ) {
    try {
      setLoading(true);
      const response =
        await TeacherAnalysisAPIServiceV2ClientWithStatusCodeHandler.getClassSubjectAnalysis(
          {
            teacherId: user_info?.teacherProfileId,
            sectionId: selectedClassInfo?.sectionId,
            subjectId: selectedClassInfo?.subjectId,
          }
        );
      // console.log(response.data);
      if (response) {
        setLoading(false);
        if (response.data) {
          dispatch(setClassSubjectAnalysis(response.data));
        }
      }
    } catch (err) {
      setLoading(false);
      setError(true);
      console.log(err);
    }
  }
  const classAndsubjectClickHandler = async (
    inputClassInfo: IClassAndSubjectSelected
  ) => {
    dispatch(setSelectedClassInfo(inputClassInfo));
    fetchClassStudentAnalytics(inputClassInfo);
    setModalState(false);
    await interactionEvent({
      context: 'all_subjects',
      name: `${inputClassInfo.classname}${inputClassInfo.section} ${inputClassInfo.subject}`,
      pathSegments: pathSegments,
      isOffline: isOffline,
    });
  };
  const subMap = getSubjectsMap();
  // console.log(
  //   'userinfo',
  //   selected_class_info,
  //   user_info,
  //   user_info?.teachClassSubjects
  //     .find(
  //       (e) =>
  //         e.className === selected_class_info?.classname &&
  //         e.sectionId === selected_class_info.sectionId
  //     )
  //     ?.subjects.find((sub) => sub.subjectName === selected_class_info?.subject)
  //     ?.iconUrl
  // );
  return loading === true ? (
    <Shimmer />
  ) : (
    <Box sx={styles.root}>
      <Box sx={styles.header}>
        <Typography variant={largeScreen ? 'h1' : 'h2'}>Analysis</Typography>
      </Box>
      {error === true ? (
        <NoContentCard variant="error" icon="error" text="Error Occured" />
      ) : (
        <Box
          sx={{
            width: { xs: '100%', md: '100%', lg: '85%' },
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: pxToRem(20), lg: pxTovW(20) },
            justifyContent: { xs: 'center', md: 'space-between' },
            alignItems: { xs: 'center', md: 'normal' },
            // backgroundColor: 'red',
          }}
        >
          <Box
            sx={{
              display: 'flex',

              flexDirection: 'column',
              gap: { xs: pxToRem(20), md: pxTovW(20) },
              justifyContent: { xs: 'center', md: 'normal' },
              alignItems: { xs: 'center', md: 'normal' },
              width: { xs: '100%', md: '40%', lg: '35%' },
            }}
          >
            {largeScreen ? (
              <Button
                sx={{
                  ...styles.dropDownButton,
                  width: isIpadOnly ? '100%' : pxTovW(552),
                }}
                onClick={() => setModalState(true)}
              >
                <Typography
                  variant={isIpadOnly ? 'h3' : 'h5'}
                  fontWeight="medium"
                >
                  {`${selected_class_info?.classname}${selected_class_info?.section}  ${selected_class_info?.subject}`}
                </Typography>
                <Box>
                  {/* <ArrowForwardIosIcon
                    sx={{
                      height: { xs: pxToRem(12.55), md: pxTovW(15) },
                      width: { xs: pxToRem(7.18), md: pxTovW(15) },
                      color: '#828282',
                    }}
                  /> */}
                  {selected_class_info?.subject && (
                    <CloseIcon
                      sx={{
                        display: 'inline-block',
                        fontSize: { xs: pxToRem(14), lg: pxTovW(18) },
                      }}
                      onClick={(ev) => {
                        ev.stopPropagation();
                        navigate(ANALYTICS_CLASS_SELECTION);
                      }}
                    />
                  )}
                </Box>
              </Button>
            ) : (
              <SecondaryButton
                styles={{
                  height: { xs: pxToRem(45) },
                  width: '90%',
                }}
                witharrow={selected_class_info?.subject ? false : true}
                onClick={() => {
                  setModalState(true);
                  try {
                    if (
                      deviceType === 'android' &&
                      android?.disableAppRefresh
                    ) {
                      console.log(
                        'App refresh disabled on Android for home page'
                      );
                      android.disableAppRefresh();
                    }
                  } catch (error) {
                    console.log(
                      'An error occurred while attempting to enable app refresh on Android:'
                    );
                  }
                }}
              >
                <Typography
                  sx={{
                    width: '100%',
                    textAlign: 'left',
                  }}
                >
                  {`${selected_class_info?.classname}${selected_class_info?.section}  ${selected_class_info?.subject}`}
                </Typography>

                {selected_class_info?.subject && (
                  <CloseIcon
                    sx={{
                      position: 'absolute',
                      right: '10px',
                      display: 'inline-block',
                      fontSize: { xs: pxToRem(14), md: pxTovW(18) },
                    }}
                    onClick={(ev) => {
                      ev.stopPropagation();
                      navigate(ANALYTICS_CLASS_SELECTION);
                      try {
                        if (
                          deviceType === 'android' &&
                          android?.enableAppRefresh
                        ) {
                          console.log(
                            'App refresh disabled on Android for home page'
                          );
                          android.enableAppRefresh();
                        }
                      } catch (error) {
                        console.log(
                          'An error occurred while attempting to enable app refresh on Android:'
                        );
                      }
                    }}
                  />
                )}
              </SecondaryButton>
            )}
            <Box sx={styles.iconCard}>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-around',
                  alignItems: 'center',
                }}
              >
                <Box sx={styles.iconBox}>
                  <Box sx={styles.iconInfo}>
                    <IconWrapper
                      name="clock"
                      size={isIpadOnly ? 'large' : 'md'}
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="h2" fontWeight="bold">
                      {Math.round(
                        Number(ClassSubjectAnalysisData?.timeSpentInMinutes)
                      )}
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    fontWeight="regular"
                    sx={{ color: '#828282' }}
                  >
                    Active Minutes
                  </Typography>
                </Box>

                <Box sx={styles.iconBox}>
                  <Box sx={styles.iconInfo}>
                    <IconWrapper
                      name="questions"
                      size={isIpadOnly ? 'large' : 'md'}
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="h2" fontWeight="bold">
                      {ClassSubjectAnalysisData?.lessonTaughts}
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    fontWeight="regular"
                    sx={{ color: '#828282' }}
                  >
                    Lessons Taught
                  </Typography>
                </Box>

                <Box sx={styles.iconBox}>
                  <Box sx={styles.iconInfo}>
                    <IconWrapper
                      name="reading"
                      size={isIpadOnly ? 'large' : 'md'}
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="h2" fontWeight="bold">
                      {(ClassSubjectAnalysisData?.assignedHwCount || 0) +
                        (ClassSubjectAnalysisData?.assignedFaCount || 0)}
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    fontWeight="regular"
                    sx={{ color: '#828282' }}
                  >
                    Assessments Assigned
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={styles.classScore}>
              <ClassScore
                path={getMediaBasePath(
                  ClassSubjectAnalysisData?.subjectIconImageUrl ||
                    user_info?.teachClassSubjects
                      .find(
                        (e) =>
                          e.className === selected_class_info?.classname &&
                          e.sectionId === selected_class_info.sectionId
                      )
                      ?.subjects.find(
                        (sub) =>
                          sub.subjectName === selected_class_info?.subject
                      )?.iconUrl,
                  'schoolnetStaticAssetBucket'
                )}
                iconName={selected_class_info?.subject || ''}
                className={`${selected_class_info?.classname}${selected_class_info?.section}  ${selected_class_info?.subject}`}
                score={
                  Number(ClassSubjectAnalysisData?.scorePercent.toFixed(2)) || 0
                }
                withButton
              />
            </Box>
          </Box>
          <StudentSection />
        </Box>
      )}
      <ClassAndSubjectPopup
        modalState={modalState}
        setModalState={setModalState}
        displayData={subjectsWithClass}
        classSubjectsList={user_info?.teachClassSubjects}
        classAndsubjectClickHandler={classAndsubjectClickHandler}
      />
    </Box>
  );
};

const subjectsWithClass = [
  { subject: 'English', icon: 'english', class: '1A' },
  { subject: 'English', icon: 'english', class: '2C' },
  { subject: 'Maths', icon: 'maths', class: '3A' },
  { subject: 'Maths', icon: 'maths', class: '3B' },
  { subject: 'Marathi', icon: 'marathi', class: '3C' },
  { subject: 'Marathi', icon: 'marathi', class: '3D' },
  { subject: 'Science', icon: 'science', class: '8A' },
  { subject: 'Science', icon: 'science', class: '8B' },
];
